import * as actionTypes from "./actionTypes";

const initialState = {
  data: [],
  collaboratorsList: [],
  plansList: [],
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        collaboratorsList: action.payload.collaboratorsList,
        plansList: action.payload.plansList,
      };

    case actionTypes.CREATE_FULFILLED:
    case actionTypes.UPDATE_FULFILLED:
    case actionTypes.DELETE_FULFILLED:
    case actionTypes.CHANGE_PLAN_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case actionTypes.GET_REJECTED:
    case actionTypes.DELETE_REJECTED:
    case actionTypes.UPDATE_REJECTED:
    case actionTypes.CREATE_REJECTED:
    case actionTypes.CHANGE_PLAN_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET:
    case actionTypes.UPDATE:
    case actionTypes.CREATE:
    case actionTypes.DELETE:
    case actionTypes.CHANGE_PLAN:
      return { ...state, isLoading: true };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
